function loadSeminar(view) {
    return () => import( /* webpackChunkName: "seminar-[request]" */ `../components/Seminar/${view}.vue`)
}
const routes = [
    {
        path: '/seminar',
        name: 'studentRegistration',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['mahasiswa']
        },
        component: loadSeminar('studentRegistration')
    },
    {
        path: '/thesis/mahasiswa/:thesis_id/seminar',
        name: 'studentRegistrationTA',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['mahasiswa']
        },
        component: loadSeminar('studentRegistration')
    },
    {
        path: '/seminar-confirmation',
        name: 'seminarConfirmation',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['administrator', 'wadek','kalab','dosen','kadep','kaprodi','sekprodi', 'laboran']
        },
        component: loadSeminar('confirmation')
    },
    {
        path: '/seminar-tester',
        name: 'seminarTester',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['administrator', 'wadek','kalab','dosen','kadep','kaprodi','sekprodi']
        },
        component: loadSeminar('ExamTesterVerification')
    },
    {
        path: '/seminar-detail/:id',
        name: 'Detail Seminar',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadSeminar('prodiConfirmation')
    },
    {
        path: '/seminar-attendance/:id',
        name: 'Seminar Attendance',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['wadek','kalab','dosen','kadep','kaprodi','sekprodi']
        },
        component: loadSeminar('ExamAttendance')
    },
    {
        path: '/seminar-note/:id',
        name: 'Seminar Note',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['wadek','kalab','dosen','kadep','kaprodi','sekprodi']
        },
        component: loadSeminar('seminarNote')
    },
    {
        path: '/seminar-result/:id',
        name: 'seminarResult',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadSeminar('seminarResult')
    },
    {
        path: '/seminar-schedule/:id',
        name: 'Seminar Schedule',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['wadek','kalab','dosen','kadep','kaprodi','sekprodi']
        },
        component: loadSeminar('ExamSchedule')
    }
]

export default routes